import { default as fastFormsConfigure } from '@ui-components-3/fast-forms/lib/utils/configure'
import makeQuery from 'api/makeQuery'
import User from 'singletons/User'

// TODO - improve types and get rid of ts ignores

export const configureFastForms = () => {
  fastFormsConfigure({
    fetchForms: (formGroups, extraParams) => {
      const filter: Record<string, any> = { form_group: formGroups[0] }
      // TODO: maybe add switch to attach different filter values per form_group
      if (extraParams.version) {
        filter.version = extraParams.version
      }

      if (!extraParams.isSuccess) {
        filter.group_section = { $ne: 'success_coaching' }
      }

      return makeQuery('getForms', { filter })
    },
    // @ts-ignore
    fetchFormResponses: (formGroups, targetIds, extraParams) => {
      switch (extraParams?.type) {
        case 'protocols': {
          if (targetIds) {
            const { groupId, clientId } = targetIds
            const filter: Record<string, any> = {
              client_id: clientId,
              group_id: groupId,
              form_group: formGroups[0],
            }
            if (extraParams.sendActive) {
              filter.active = true
            }

            return makeQuery('getCareProtocols', {
              filter,
            })
          }
          break
        }
        case 'safety_plan': {
          if (targetIds) {
            const { pendingVisitId } = targetIds
            const visit = User.provider?.visitQueue.getById(pendingVisitId)
            if (visit?.safetyPlan?.form) {
              return [
                {
                  form: visit.safetyPlan.form,
                },
              ]
            }
          }
          return []
        }
        // SafetyPlan presence varies when viewing past visits page vs. Visit>visitsTab, so passing as extra param for consistency when "fetching" form responses bc it is present in component calling fetchFormGroups
        case 'safety_plan_past': {
          if (extraParams.safetyPlan) {
            return [
              {
                form: extraParams.safetyPlan.form,
              },
            ]
          }
          return []
        }
      }
      throw new Error('Wrong responses')
    },
    // @ts-ignore
    submitForm: async (formBase, targetIds, extraParams) => {
      switch (extraParams?.type) {
        case 'safety_plan': {
          if (targetIds) {
            const { visitId, pendingVisitId } = targetIds
            const form = {
              formId: formBase.form.formId,
              answers: formBase.answers,
              // for by field submission switch to answers: [{fieldId: formBase.fieldId value: formBase.value }]
            }
            const data = await makeQuery('putSafetyPlan', {
              // @ts-ignore
              form,
              visitId,
            })
            const visit = User.provider?.visitQueue.getById(pendingVisitId)
            visit.merge(data)
            return {
              form: data?.safetyPlan?.form,
            }
          }
        }
      }
      throw new Error('No submit method for this type of form')
    },
  })
}
